var _ellipse, _ellipse2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBody7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: -211,
    cy: 489,
    rx: 430,
    ry: 412,
    fill: "#F44C7F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 432.5,
    cy: 685,
    rx: 339.5,
    ry: 325,
    fill: "#D7EFF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1737.62 307.538C1697.13 267.05 1697.13 201.405 1737.62 160.917L1898.29 0.242947C1938.78 -40.2452 2004.43 -40.2452 2044.91 0.24289C2085.4 40.731 2085.4 106.375 2044.91 146.863L1884.24 307.538C1843.75 348.026 1778.11 348.026 1737.62 307.538Z",
    fill: "#F44C7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.13 284.176C1402.8 233.845 1402.8 152.241 1453.13 101.91L1778.38 -223.333C1828.71 -273.664 1910.31 -273.664 1960.64 -223.332C2010.97 -173.001 2010.97 -91.3972 1960.64 -41.0656L1635.4 284.177C1585.07 334.508 1503.47 334.508 1453.13 284.176Z",
    fill: "#D7EFF4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody7);
export default __webpack_public_path__ + "static/media/body_7.c2f9e8dd2e8da443c75ab44d52bce7f8.svg";
export { ForwardRef as ReactComponent };